const key = "allow-customer-management";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]+\/security$/);
};

const modify = (resp) => {
	if(resp.data.Success !== true || !resp.data.Data) {
		return;
	}
	
	const assigned = resp.data.Data.Assigned;
	const role = resp.data.Data.Roles.find(r => r.Code === assigned[0].Code);

	const allowEntityCustomer = { Effect: "Allow", Path: "/types/FISHERMAN/customers/*/{read,create}" };
	role.Actions.push(allowEntityCustomer);

	const allowCustomer = { Effect: "Allow", Path: "/customers/**/*" };
	role.Actions.push(allowCustomer);
};

export const allowCustomerManagement = [key, applicable, modify];